module.exports = __webpack_public_path__ + "img/钱箱.5cf13992.png";